module.exports = __webpack_public_path__ + "img/logo-light.5a53bd97.png";